import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 显示重量单位
        showUnitType: ''
    },
    getters: {
    },
    mutations: {
        // 给 state 设置数据
        setStateDataFn(store, data) {
            Object.keys(data).forEach(key => store[key] = data[key]);
        },

    },
    actions: {
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js